var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"318ab9485e06ff8a7b9028b549e8b8b153780821"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["soraban-ys@soraban-ys"]={id:"318ab9485e06ff8a7b9028b549e8b8b153780821"};
      